import * as React from 'react'
import { useEffect, useState } from 'react'
import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'
import { useTranslation } from 'react-i18next'
import { api } from '../api/api'
import '../css/partners.css'
import { tagger, spanirizerByString, localeToInternalLang } from '../util/util'
import { locales } from '../util/locales'

const Partners = () => {
    const { t, i18n } = useTranslation('landing')

    const [reviews, setReviews] = useState([])

    const loadData = async () => {
        const language = localeToInternalLang.get(i18n.language)?.apiLang
        const reviewsResult = await api.reviews(language || locales.en)
        const reviews = reviewsResult.results
        setReviews(reviews)
    }

    useEffect(() => {
        loadData()
    }, [i18n.language])

    const handleOnDragStart = (e) => e.preventDefault()

    const renderReview = (review) => {
        return (
            <div key={review._id} onDragStart={handleOnDragStart} className="review-item">
                <div className="carousel-inline-img review-image" style={{ backgroundImage: 'url(' + encodeURI(review.image) + ')' }} />
                <div className="user-photo"><img src={encodeURI(review.writerImage)} /></div>
                <div className="user-description">
                    <div className="user-name accent-text">{review.writerName}</div>
                    <div className="user-position">{review.writerTitle} @ {review.writerCompanyName}</div>
                    <div className="user-review">{spanirizerByString(review.text, 'Persona.ly', 'accent-text fw700')}</div>
                    {review.writerCaseStudyUrl && <a href={review.writerCaseStudyUrl} target="_blank" rel="noopener noreferrer">
                        <button className="button-review">{t('read case')}</button>
                    </a>}
                </div>
            </div>
        )
    }

    const renderReviewList = () => {
        return reviews
            .sort((a: any, b: any) => a.priority - b.priority)
            .map((review: any) => renderReview(review))
    }

    const carousel = React.useRef<AliceCarousel>(null)

    const handlePrevPageChange = () => {
        carousel?.current?.slidePrev()
    }

    const handleNextPageChange = () => {
        carousel?.current?.slideNext()
    }

    return (
        <div className="partners">
            <p className="muli">{tagger(t('Our Partners'), 'accent-text')}</p>
            <div>
                <p>{t('here s what t')}</p>
                <div className="reviews carousel-inline">
                    <img
                        className={'prev not-mobile not-tablet prev-h'}
                        src="https://static.persona.ly/images/partners/path-2-copy-2.svg"
                        onClick={handlePrevPageChange}
                    />
                    <AliceCarousel
                        mouseTrackingEnabled
                        buttonsDisabled
                        items={renderReviewList()}
                        ref={carousel}
                        responsive={{
                            0: {
                                items: 1,
                            },
                            1105: {
                                items: 2
                            }
                        }}
                    />
                    <img
                        className={'next not-mobile not-tablet next-h'}
                        src="https://static.persona.ly/images/partners/path-2-copy-2.svg"
                        onClick={handleNextPageChange}
                    />
                </div>
            </div>
            <div className="partners-integrations">
                <div>{t('Attribution p')}
                    <img src="https://static.persona.ly/images/partners/group-19.svg" />
                </div>
                <div>{t('Analytics i')}
                    <img src="https://static.persona.ly/images/partners/group-21.svg" />
                </div>
            </div>
        </div>
    )

}

export default Partners


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/partners.tsx